'use client'

import SectionLayout from '@component/layout/section'
import ListingsStandard, { SkeletonCard, SoldStandard } from '@component/card/listings/standard'
import LsitingsTab from '../tab'
import { useMemo, useState } from 'react'
import { AgentListingsContext } from '../context'
import { first, get, isEqual, map, range, size } from 'lodash-es'
import useFetch from '@hooks/useFetch'
import { HOUSE_TYPE_ID } from '@config'
import Pagination from '@component/pagination'
import { agentDataLayer } from '@plugin/google/gtm/modules/agent'

export const LISTING_TAB = [
  { label: 'For sale', value: 'sale', typeIds: [HOUSE_TYPE_ID.buy, HOUSE_TYPE_ID['commercial-property-for-sale'], HOUSE_TYPE_ID.rural, HOUSE_TYPE_ID['businesses-for-sale']] },
  { label: 'Sold', value: 'sold', typeIds: [HOUSE_TYPE_ID.sold] },
  { label: 'For lease', value: 'lease', typeIds: [HOUSE_TYPE_ID.rent, HOUSE_TYPE_ID.leased] }
]
const LISTING_TAB_COMINING_SOON = { label: 'Coming soon', value: 'coming-soon', typeIds: LISTING_TAB[0].typeIds, }

export default function AgentListingsContent({
  agent,
  forSaleDefaultData,
  forSaleDefaultParams,
  forSaleTotals,
  comingSoonTotals,
  pageIndex,
  pageSize
}) {

  const tabs = useMemo(() => {
    let res = Array.from(LISTING_TAB)
    if (comingSoonTotals > 0) {
      res.splice(1, 0, LISTING_TAB_COMINING_SOON)
    }
    return res
  }, [comingSoonTotals])
  const [tab, setTab] = useState(first(tabs))
  const [pageIdx, setPageIdx] = useState(pageIndex)
  const params = useMemo(() => {
    const res = {
      limit: pageSize,
      offset: (pageIdx - 1) * pageSize,
      typeId: tab.typeIds.join(',')
    }
    if (tab.value === 'coming-soon') {
      res.sellStatus = 4
    }
    return res
  }, [tab, pageIdx, pageSize])
  const isSold = tab.value === 'sold'
  const isDefault = isEqual(forSaleDefaultParams, params)
  const { data, isLoading } = useFetch(isDefault ? null : { url: `agent/${agent.id}/houses`, params })
  const viewData = isDefault ? forSaleDefaultData : data
  const viewTotals = useMemo(() => {
    let res = forSaleTotals
    if (!isDefault && data) {
      res = get(data, 'headers.x-total-count')
    }
    return res
  }, [forSaleTotals, isDefault, data])

  function changeTab(tab) {
    setTab(tab)
    setPageIdx(1)

    agentDataLayer.listingTabClick(tab.value, agent.id)
  }
  function changeHandle(idx) {
    setPageIdx(idx)
  }
  return (
    <AgentListingsContext.Provider value={{ tab, changeTab }}>
      <SectionLayout title={`All Listings by ${agent.name}`} titleRight={<LsitingsTab tabs={tabs}></LsitingsTab>}>
        <div className='grid gap-16 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
          {
            isLoading && (
              map(range(0, 8), idx => (
                <SkeletonCard key={idx}></SkeletonCard>
              ))
            )
          }
          {
            !isLoading && size(viewData) > 0 && (
              map(viewData, item => (
                isSold
                  ? <SoldStandard data={item} key={item.id}></SoldStandard>
                  : <ListingsStandard data={item} key={item.id}></ListingsStandard>
              ))
            )
          }</div>
        {
          viewTotals > pageSize && !isLoading && <Pagination className='mt-24' right pageIndex={pageIdx} pageSize={pageSize} totals={viewTotals} onChange={changeHandle}></Pagination>
        }
      </SectionLayout>
    </AgentListingsContext.Provider>
  )
}